import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import AppButton from "@/features/line-sheet-sets/app-button";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

// KREAM 구분 항목의 파일 다운로드 시 노출하는 입찰가 입력 안내 모달
function PathPickKreamBidGuideModal({ isOpen, onClose }: Props) {
  const { t } = useI18nHelper();

  return (
    <CustomApprovalModal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <CustomApprovalModal.Header
        onClose={onClose}
        title={t("path_pick:sync_download_history.kream_bid_guide.title")}
      />
      <CustomApprovalModal.Body>
        <Flex flexDirection={"column"} gap={"12px"}>
          <Text textStyle={"body-md-regular"} color={"#1D1D1B"}>
            {t("path_pick:sync_download_history.kream_bid_guide.body")}
          </Text>
          {/* 확인 버튼만 필요해서 공용 Footer(취소 버튼 고정 노출) 대신 직접 렌더한다. */}
          <Flex justifyContent={"flex-end"}>
            <AppButton variant={"primary"} width={"80px"} onClick={onClose}>
              <Text textStyle={"body-sm-bold"}>
                {t("path_pick:sync_download_history.kream_bid_guide.confirm")}
              </Text>
            </AppButton>
          </Flex>
        </Flex>
      </CustomApprovalModal.Body>
    </CustomApprovalModal>
  );
}

export default PathPickKreamBidGuideModal;
